
import * as React from 'react';
import styled from 'styled-components';
import * as lo from 'lodash/fp';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { DataGrid } from '@process-advisor/process-miner/modals/detail/dataGrid';
import { eventDetailGridColumns } from '@process-advisor/process-miner/model/events/eventDetailGridColumns';

type Row = {};
let columns = []
const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;

export const EventDetailGrid: React.FC = () => {
    const [data, setData] = React.useState<Row[]>([]);

    React.useEffect(() => {
        apiProvider.setEventDetailExtract({type: 'detail'})
        apiProvider.setDetailSource({source: 'all'})
        setData(apiProvider.processDetailEventSummary());
    }, []);

    const rows = data.map((row, id) => ({ id, ...row }));
    if (lo.isEmpty(columns)) {
        columns = eventDetailGridColumns(rows);
    }
    
    return (
        <Wrapper>
            <DataGrid
                rows={rows}
                columns={columns}
                type={'event-detail'}
                height="500px" />
        </Wrapper>
    );
};
